import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UnicodeEntity } from '@mews/enums';
import { ApplicationState } from '@mews-commander/types';
import { getCategoryShortcut } from '../../../selectors/categories';

interface StateProps {
    shortcut: string;
}

interface OwnProps {
    id: string;
    scope: string;
}

const CategoryShortcut = ({ shortcut }: { shortcut: string }) => <span>{shortcut || UnicodeEntity.Dash}</span>;

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        shortcut: getCategoryShortcut,
    })
)(CategoryShortcut);
